var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"solicitacao"},[_c('h1',[_vm._v(" Obrigado! ")]),_c('hr'),_c('p',[_vm._v(" Status da solicitação: "),_c('strong',[_vm._v(_vm._s(_vm.status))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }